angular.module('app.controllers').controller 'JobsEditCtrl', [
  '$scope', '$location', 'UI', 'APIRead2', '$rootScope'
].append (self, $location, UI, APIRead2, root) ->

  self.id = parseInt(self.get('id')) || null
  self.job_id = if parseInt(self.get('job_id')) == 0 then 0 else parseInt(self.get('job_id')) || null

  if root.user?.role == 'exhibitor'      
    return root.logout() unless self.id == root.session?.user?.id

  APIRead2.query {entry_type: 'open_jobs', exclude: self.job_id, exhibitor_id: self.id, orderby: 'random'}, (data) ->
    self.jobs = data
  , (response) ->
    UI.notify false, response.error.data
  
  APIRead2.get {id: self.id, entry_type: 'exhibitors'}, (data) ->
    self.exhibitor = data

    contact = []
    for i in ['exhibitor_name', 'street', 'zip_code', 'city', 'country']
      contact.push(self.exhibitor[i]) if self.exhibitor[i]?

    self.contact = contact.join("\n")

    APIRead2.get {id: self.job_id, exhibitor_id: self.id, entry_type: 'open_jobs'}, (data) ->
      self.data = data
      self.customStat(self.data.exhibitor_id, 'job_seen', self.data.title)

      if self.data.video.is_yuotube
        self.onYouTubeIframeAPIReady(self.data.video.id, self.data.exhibitor_id, self.data.title)
      else if self.data.video.is_vimeo
        self.onVimeoIframeAPIReady(self.data.video.id, self.data.exhibitor_id, self.data.title)


    , (response) ->
      UI.notify false, response.error.data
      return $location.path('/offene-lehrstellen')

  , (response) ->
    UI.notify false, response.error.data



  self.slick =    
    infinite: true
    dots: true
    arrows: true
    dotsClass: 'slider-dots'
    customPaging: (slider, i) -> 
      return false if slider.slideCount == 1 || slider.slideCount <= slider.options.slidesToShow
      return "<a class='slider-dots-item'></a>"

    slidesToShow: 3
    slidesToScroll: 3
    prevArrow: '<div class="slider-control slider-control-prev"></div>'
    nextArrow: '<div class="slider-control slider-control-next"></div>'
    speed: 500
    fade: false
    autoplay: false
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'

    responsive: [
      {
        breakpoint: 1200
        settings: 
          slidesToShow: 2
          slidesToScroll: 2
          arrows: true
      }
      {
        breakpoint: 768
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          arrows: false
      }
    ]